import script from "./edit3Id.vue?vue&type=script&lang=ts&setup=true"
export * from "./edit3Id.vue?vue&type=script&lang=ts&setup=true"

import "./edit3Id.vue?vue&type=style&index=0&id=21ad6492&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21ad6492"]])

export default __exports__